import { Table, Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { FecAccountMapping } from '../../../../../../types/fecAccountMapping'
import { ChartOfAccountsTableRow } from '../ChartOfAccountsTableRow'

interface ChartOfAccountsTableBodyProps {
  isLoading: boolean
  mappings: FecAccountMapping[]
}

export const ChartOfAccountsTableBody = ({ isLoading, mappings }: ChartOfAccountsTableBodyProps): ReactElement => {
  const { t } = useTranslation()

  if (isLoading) {
    return <Table.Skeleton columns={4} />
  }

  if (mappings.length === 0) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={4}>
            <Typography.Text>
              {t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.empty')}
            </Typography.Text>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    )
  }

  return (
    <Table.Body>
      {mappings.map((mapping) => (
        <ChartOfAccountsTableRow key={mapping.id} mapping={mapping} />
      ))}
    </Table.Body>
  )
}
